type Locale = "it" | "en";

const FRIDAY = 5;

/** yyyy-mm-dd da parti locali (non UTC) — evita lo shift di fuso di toISOString(). */
export function getTodayIsoDate(now: Date = new Date()): string {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Default sensato per il form: il prossimo venerdì (oggi stesso se è già venerdì). */
export function getDefaultReservationDate(now: Date = new Date()): string {
  const daysUntilFriday = (FRIDAY - now.getDay() + 7) % 7;
  const target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilFriday);
  return getTodayIsoDate(target);
}

/** "sabato 12 settembre" / "Saturday 12 September" — niente anno, per il messaggio WhatsApp. */
export function formatReservationDate(isoDate: string, locale: Locale): string {
  const date = new Date(`${isoDate}T00:00:00`);
  const intlLocale = locale === "en" ? "en-GB" : "it-IT";
  const parts = new Intl.DateTimeFormat(intlLocale, { weekday: "long", day: "numeric", month: "long" }).formatToParts(
    date
  );
  const part = (type: string) => parts.find((p) => p.type === type)?.value ?? "";
  return `${part("weekday")} ${part("day")} ${part("month")}`;
}
